import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { LocationStateTable } from './table';

export function LocationStatesTab({ importTypeId, importTypeName }: TabProps) {
    return (
        <TabsContent value="locationStates">
            <Card>
                <CardHeader>
                    <CardTitle>Location States</CardTitle>
                    <CardDescription>Location State Mappings for {importTypeName} - {importTypeId}</CardDescription>
                </CardHeader>
                <CardContent className="space-y-2">
                    <LocationStateTable importTypeId={importTypeId} />
                </CardContent>
            </Card>
        </TabsContent>
    );
}
